import { useEffect, useState } from "react";
import PageTitle from "../../../module/pageTitle";
import AdminTable from "../../../Component/adminTable";
import LabelInput from "../../../Component/labelInput";
import { InputField, Submitbtn } from "../../../Component";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../../store";
import {
  deleteBaseOffer,
  getBaseOfferById,
  getBaseOfferList,
  getCategoryList,
  getProductTypeList,
  updateBaseOffer,
} from "../adminSlice";
import { containsNumber } from "../../../Utils/validators";
import { validateValueWithoutSpace } from "../../../Utils/validators";
import { validateIsNumberOnlyErrMsg } from "../../../Utils/errorMsg";
import DropdownWithClear from "../../../Component/dropdownWithClear";
import ToggleSwitchButton from "../../../Component/toggleSwitchButton";
import { showSnackbar, hideSnackbar } from "../../../store/slices/snackbarSlice";

const EditDeleteBaseOffer = () => {
  const dispatch = useDispatch<AppDispatch>();
  const [isEditMode, setisEditMode] = useState<Boolean>(false);
  const [baseOfferList, setBaseOfferList] = useState<any>([]);
  const [productTypeList, setProductTypeList] = useState<any>([]);
  const [productType, setProductType] = useState<any>("");
  const [category, setCategory] = useState<any>("");
  const [categoryList, setCategoryList] = useState<any>([]);
  const [discount, setDiscount] = useState<any>("");
  const [baseOfferId, setBaseOfferId] = useState<any>("");
  const [baseOfferData, setBaseOfferData] = useState<any>("");
  const [toggle, setToggle] = useState<any>(false);
  const [productTypeToggle, setProductTypeToggle] = useState<any>(false);
  const [categoryTypeToggle, setCategoryTypeToggle] = useState<any>(false);

  useEffect(() => {
    getData();
  }, []);

  const getData = () => {
    dispatch(
      getBaseOfferList({
        callback: (res: any) => {
          setBaseOfferList(res?.data);
        },
        errorCallback: () => { },
      })
    );
  };
  const onchangeProductType = (value: any) => {
    const postData = {
      productTypeId: value?._id,
    };
    dispatch(
      getCategoryList({
        params: postData,
        callback: (res: any) => {
          setCategoryList(res);
          setCategory("");
        },
        errorCallback: (error: any) => { },
      })
    );
    setProductType(value);
  };

  const onchangeCategory = (value: any) => {
    setCategory(value);
  };

  const changeToggle = (event: any, key: string) => {
    if (event.target.checked && key === 'global') {
      setToggle(true);
      setProductTypeToggle(false);
      setCategoryTypeToggle(false);
    } else if (event.target.checked && key === 'productType') {
      setProductTypeToggle(true);
      setCategoryTypeToggle(false);
      setToggle(false);
    } else if (event.target.checked && key === 'categoryType') {
      setCategoryTypeToggle(true);
      setProductTypeToggle(false);
      setToggle(false);
    } else {
      setToggle(false);
      setProductTypeToggle(false);
      setCategoryTypeToggle(false);
    }
  };

  const onchangeDiscount = (value: any) => {
    if (value !== "") {
      if (!containsNumber(value)) {
        return;
      } else if (!validateValueWithoutSpace(value)) {
        return;
      } else {
        setDiscount(value);
      }
    } else {
      setDiscount(value);
    }
  };
  const validations = () => {
    return (
      (toggle && discount === "") ||
      (productTypeToggle && !productType?.name) ||
      (categoryTypeToggle &&
        (
          !productType?.name ||
          !category?.name ||
          discount === ""
        )
      )
    );
  };
  const handleSubmit = (e: any) => {
    e.preventDefault();
    const postData: any = {};

    if (baseOfferData?.productType?.productType !== productType?.productType) {
      postData["productType"] = productType?.productType;
    }
    if (baseOfferData?.categoryId?._id !== category?._id) {
      postData["categoryId"] = category?._id;
    }
    if (baseOfferData?.discPer !== discount) {
      postData["discPer"] = discount;
    }
    if (baseOfferData?.global !== toggle) {
      postData["global"] = toggle;
    }

    dispatch(
      updateBaseOffer({
        id: baseOfferId,
        params: postData,
        callback: (res: any) => {
          getData();
          setisEditMode(false);
          setToggle(false);
          setProductTypeToggle(false);
          setCategoryTypeToggle(false);
          dispatch(showSnackbar({ message: res?.msg, type: res?.type }));
          setTimeout(() => {
            hideSnackbar();
          }, 5000);
        },
        errorCallback: (error: any) => {
          dispatch(showSnackbar({ message: error?.data?.msg, type: error?.data?.type }));
          setTimeout(() => {
            hideSnackbar();
          }, 5000);
        },
      })
    );
  };

  const handleEdit = (value: any) => {
    setisEditMode(true);
    setBaseOfferId(value?._id);
    dispatch(
      getBaseOfferById({
        id: value?._id,
        callback: (res: any) => {
          setBaseOfferData(res?.data);
          setDiscount(res?.data?.discPer);
          if (res?.data?.global && !res?.data?.productType && !res?.data?.categoryId) {
            setToggle(res?.data?.global);
            setProductTypeToggle(false);
            setCategoryTypeToggle(false);
          }
          if (res?.data?.productType && !res?.data?.categoryId && res?.data?.global === false) {
            setToggle(res?.data?.global);
            setProductTypeToggle(true);
            setCategoryTypeToggle(false);
          }
          if (res?.data?.categoryId && res?.data?.productType && res?.data?.global === false) {
            setToggle(res?.data?.global);
            setProductTypeToggle(false);
            setCategoryTypeToggle(true);
          }
          dispatch(
            getProductTypeList({
              callback: (resp: any) => {
                setProductTypeList(resp?.data);
                let tempProductType = resp?.data?.find(
                  (item: any) => res?.data?.productType === item?._id
                );
                setProductType(tempProductType);
              },
              errorCallback: () => { },
            })
          );

          const postData = {
            productTypeId: res?.data?.productType,
          };
          dispatch(
            getCategoryList({
              params: postData,
              callback: (response: any) => {
                setCategoryList(response);
                let tempCategory = response?.find(
                  (item: any) => res?.data?.categoryId?._id === item?._id
                );
                setCategory(tempCategory);
              },
              errorCallback: (error: any) => { },
            })
          );
        },
        errorCallback: (error: any) => { },
      })
    );
  };
  const handleDelete = (value: any) => {
    dispatch(
      deleteBaseOffer({
        id: value?._id,
        callback: (res: any) => {
          setisEditMode(false);
          getData();
        },
        errorCallback: () => { },
      })
    );
  };
  const renderTable = () => {
    return (
      <AdminTable
        tableData={baseOfferList ? baseOfferList : []}
        pagename={"BaseOffer"}
        tableHead={["S.N", "Category ", "Discount Value", "Action"]}
        handleEdit={(value: any) => handleEdit(value)}
        handleDelete={(value: any) => handleDelete(value)}
        edit={true}
      />
    );
  };

  const renderEditMode = () => {
    return (
      <form onSubmit={handleSubmit}>
        <div className="row">
          <div className="col-md-5">
            <div className="col-md-12 mb-3 d-flex">
              <LabelInput labelName={"Global"} />
              <div className="col-6 ms-auto">
                <ToggleSwitchButton
                  getToggleval={(value: any) => {
                    changeToggle(value, "global");
                  }}
                  isActive={toggle}
                />
              </div>
            </div>
            <div className="col-md-12 mb-3 d-flex">
              <LabelInput labelName={"Product Type Base Offer"} />
              <div className="col-md-6 ms-auto">
                <ToggleSwitchButton isActive={productTypeToggle}
                  getToggleval={(value: any) => {
                    changeToggle(value, "productType");
                  }}
                />
              </div>
            </div>
            <div className="col-md-12 mb-3 d-flex">
              <LabelInput labelName={"Category Type Base Offer"} />
              <div className="col-md-6 ms-auto">
                <ToggleSwitchButton isActive={categoryTypeToggle}
                  getToggleval={(value: any) => {
                    changeToggle(value, "categoryType");
                  }}
                />
              </div>
            </div>
          </div>
          <div className="col-md-7">
            {toggle === true && !productTypeToggle && !categoryTypeToggle ? null : !toggle && (productTypeToggle || categoryTypeToggle) ?
              <div className="col-md-10 mb-3">
                <LabelInput labelName={"Product type"} isRequired />
                <DropdownWithClear
                  labelName={"Select Product type"}
                  setInputText={(value: any) => onchangeProductType(value)}
                  options={productTypeList}
                  value={productType}
                />
              </div> : null}
            {toggle === true && !productTypeToggle && !categoryTypeToggle ? null : !toggle && !productTypeToggle && categoryTypeToggle ?
              <div className="col-md-10 mb-3">
                <LabelInput labelName={"Product category "} isRequired />
                <DropdownWithClear
                  labelName={"Select Product category "}
                  setInputText={(value: any) => onchangeCategory(value)}
                  options={categoryList}
                  value={category}
                />
              </div>
              : null}
            {(toggle || productTypeToggle || categoryTypeToggle) && (
              <>
                <div className="col-md-10 mb-3">
                  <LabelInput labelName={"Discount Value(%)"} isRequired />
                  <InputField
                    key={"ex2"}
                    placeholder={"Enter Discount Value Precent"}
                    setInputText={(value: any) => onchangeDiscount(value)}
                    value={discount}
                    maxLength={3}
                  />
                </div>

                <div className="d-flex justify-content-center mt-3">
                  <div className="col-3 pt-2">
                    <Submitbtn name={"Submit"} disabled={validations()} />
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </form>
    );
  };
  const handleGoBack = () => {
    setisEditMode(false);
  };
  return (
    <div className="panel-content">
      <div className="mb-4">
        <PageTitle
          name={"Edit / Delete Base Offer"}
          breadCrumb={""}
          isEditMode={isEditMode}
          setisEditMode={setisEditMode}
          cancelEdit={() => handleGoBack()}
        />
      </div>
      <div className="formDiv">
        <div className={`bxshadow borderRadius ${isEditMode ? "editMode" : "p-2"}`}>
          {isEditMode ? renderEditMode() : renderTable()}
        </div>
      </div>
    </div>
  );
};

export default EditDeleteBaseOffer;
